import computedStyle from '../../utils/computedStyle';
import Accordion from '../../components/accordion';
import RapidMessageModal from '../../components/rapidMessageModal';

export default class Footer {
  constructor() {
    this.$jsAccordionClass = '.accordion';
    this.$rapidMessage = $('.rapid-message-dialog');
  }

  init() {
    const mobile = $(window).innerWidth() <= parseInt(computedStyle.get('--breakpoint-lg'));

    if (this.$jsAccordionClass.length > 0) {
      new Accordion().init(this.$jsAccordionClass);
    }
    if (this.$rapidMessage.length > 0 && mobile) {
      new RapidMessageModal().init();
    }
    this.handlerFlyerModal();
  }

  handlerFlyerModal() {
    $(document).on('click', '.btn-flyer', function () {
      const iframeURL = $(this).attr('data-flyer-url');
      $('#flyer-modal .flyer-iframe').attr('src', iframeURL);
    });
  }
}
